import { useSetRecoilState, useRecoilState, useResetRecoilState } from 'recoil';
import { Apis, Labels } from '../../app.constants';
import SweetAlert from '../../../components/Shared/Notification';
import APIService from '../../APIService';

const OrganisationActions = () => {

    const createAddress = async (data) => {
        const res = await APIService.post(Apis.addUpdateCompanyAdd, data);
        return res;
    }
    const getAddress = async (companyId) => {
        const res = await APIService.get(`${Apis.addUpdateCompanyAdd}?company_id=${companyId}`);
        return res;
    }

    const deleteAddress = async (data) => {
        const res = await APIService.remove(Apis.addUpdateCompanyAdd, data);
        return res;
    }
    const createCompanyGst = async (data) => {
        const res = await APIService.post(Apis.createCompanyGst, data);
        return res;
    }
    const getCompanyGst = async (companyId) => {
        const res = await APIService.get(`${Apis.createCompanyGst}?company_id=${companyId}`);
        return res;
    }

    const deleteCompanyGst = async (data) => {
        const res = await APIService.remove(Apis.createCompanyGst, data);
        return res;
    }

    /**
   * Fetch organisations list
   * @param params object with sourceOrganisationId, nextPage, search string
   */
  const getOrganisations = async ({ sourceOrganisationId, nextPage = 1, search = '' }) => {
    const url = `${Apis.organisationMap}?source_organisation_id=${sourceOrganisationId}&next_page=${nextPage}&search=${encodeURIComponent(search)}`;
    const res = await APIService.get(url);
    return res;
  };

  /**
   * Fetch organisation details + accounts
   * @param organisationId string
   */
  const getOrganisationDetails = async (organisationId) => {
    const url = `${Apis.account}?organisation_id=${organisationId}`;
    const res = await APIService.get(url);
    return res;
  };

  /**
   * Fetch proposals for given account
   * @param accountId string
   */
  const getAccountProposals = async (accountId) => {
    const url = `${Apis.accountProposals}?account_id=${accountId}`;
    const res = await APIService.get(url);
    return res;
  };


    return {
        createAddress,
        getAddress,
        deleteAddress,
        createCompanyGst,
        getCompanyGst,
        deleteCompanyGst,
        getOrganisations,
       getOrganisationDetails,
       getAccountProposals,
    }
}

export { OrganisationActions };